const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/quiz/v1frontend/knowledge/view', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
